import * as Yup from 'yup'

export const ValidateSchemaOrg = Yup.object().shape({
    phone: Yup.string()
        .required('Телефон является обязательным полем')
        .matches(
            /^\+7-\d{3}-\d{3}-\d{2}-\d{2}$/,
            'Телефон должен быть в формате +7-XXX-XXX-XX-XX',
        ),
    email: Yup.string()
        .email('Введите корректный email')
        .required('Email является обязательным полем'),
    additional_data: Yup.object().shape({
        documents: Yup.object().shape({
            organization_name: Yup.string()
                .min(1, 'Название организации не может быть пустым')
                .max(100, 'Название организации не должно превышать 100 символов')
                .required('Название организации является обязательным'),
            legal_address: Yup.string()
                .min(1, 'Юр. адрес не может быть пустым')
                .max(100, 'Юр. адрес не должен превышать 100 символов')
                .required('Юр. адрес является обязательным'),
            inn: Yup.string()
                .min(10, 'ИНН должен содержать минимум 10 цифр')
                .max(12, 'ИНН не должен превышать 12 цифр')
                .required('ИНН является обязательным полем'),
        }),
    }),
    contacts: Yup.array().of(
        Yup.object().shape({
            first_name: Yup.string()
                .min(1, 'Имя не может быть пустым')
                .max(100, 'Имя не должно превышать 100 символов')
                .required('Имя является обязательным'),
            surname: Yup.string()
                .min(1, 'Фамилия не может быть пустой')
                .max(100, 'Фамилия не должна превышать 100 символов')
                .required('Фамилия является обязательной'),
            email: Yup.string()
                .email('Введите корректный email')
                .required('Email является обязательным полем'),
        }),
    ),
})

export const ValidateSchemaOrgContact = Yup.object().shape({
    first_name: Yup.string()
        .min(2, 'Имя должно содержать минимум 2 символа')
        .max(20, 'Имя не должно превышать 20 символов')
        .required('Имя является обязательным'),
    surname: Yup.string()
        .min(2, 'Фамилия должна содержать минимум 2 символа')
        .max(20, 'Фамилия не должна превышать 20 символов')
        .required('Фамилия является обязательной'),
    email: Yup.string()
        .email('Введите корректный email')
        .required('Email является обязательным полем'),
})
